import React, { useState } from 'react';
import { API } from '../../App';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { apiError } from '../../lib/apiError';

const RequestJoinDialog = ({ session, onClose, onDone }) => {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/sessions/${session.id}/join-requests`, { message: message || null });
      toast.success('Request sent! The host will accept or reject it.');
      setMessage('');
      onDone();
    } catch (e) {
      toast.error(apiError(e, 'Could not send request'));
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={!!session} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent data-testid="request-join-dialog">
        <DialogHeader>
          <DialogTitle>Request to join</DialogTitle>
          <DialogDescription>
            {session?.subject} with {session?.teacher_name}. The host has already paid for every place, so joining is
            free on the platform once they accept.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2">
          <Label htmlFor="join-message">Message to the host (optional)</Label>
          <Textarea
            id="join-message"
            rows={3}
            maxLength={300}
            placeholder="e.g. I'm also preparing for JEE and stuck on this chapter"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            data-testid="join-message-input"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={onClose}>Cancel</Button>
          <Button onClick={send} disabled={sending} className="bg-violet-600 hover:bg-violet-700 text-white rounded-full" data-testid="send-join-request-button">
            {sending ? 'Sending...' : 'Send Request'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RequestJoinDialog;
